/*
* Configuration for Meta Tags
*/
export default function () {
  return {
    cart: {
      meta: {
        title: 'Shopping Cart',
        description: 'Shopping Cart',
        keywords: ''
      }
    },
    checkout: {
      meta: {
        title: 'Checkout',
        description: 'Checkout',
        keywords: ''
      }
    },
    designer: {
      meta: {
        title: 'Customize your product',
        description: 'Customize Your product and add to Cart'
      }
    },
    search: {
      meta: {
        title: 'Custom USB Products: Flash Drives, Headphones, Mobile Chargers, and More',
        description: 'Custom USB Products for marketing campaigns, promotional giveaways, corporate gifts, conferences and more. We offer a wide selection of Customized USB Flash Drive and related products to suit your organization\'s needs.',
        keywords: 'Product Super Search,custom usb,usb products,personalized usb,promotional usb,logo usb,customized usb,flash drive,custom flash memory,custom memory cards,headphones,earbuds,audio,speakers,mobile chargers,'
      }
    },
    customer: {
      meta: {
        title: 'Customer Dashboard',
        description: 'Customer Dashboard'
      },
      sub: {
        campaigns: {
          meta: {
            title: 'Campaigns - Customer'
          }
        },
        orders: {
          meta: {
            title: 'Order History - Customer'
          }
        },
        projects: {
          meta: {
            title: 'My Products - Customer'
          }
        },
        gallery: {
          meta: {
            title: 'Artwork Gallery - Customer'
          }
        },
        referrals: {
          meta: {
            title: 'My Referrals - Customer'
          }
        },
        information: {
          meta: {
            title: 'My Account Information - Customer'
          }
        },
        payments: {
          meta: {
            title: 'Payment Options - Customer'
          }
        },
        addresses: {
          meta: {
            title: 'Address Book - Customer'
          }
        }
      }
    },
    guest: {
      meta: {
        title: '',
        description: ''
      },
      sub: {
        signin: {
          meta: {
            title: 'Sign In'
          }
        },
        signup: {
          meta: {
            title: 'Sign Up'
          }
        },
        signout: {
          meta: {
            title: 'Sign Out'
          }
        },
        'reset-password': {
          meta: {
            title: 'Reset Password'
          }
        }
      }
    },
    sitemap: {
      meta: {
        title: 'Sitemap',
        description: 'Sitemap',
        keywords: ''
      }
    },
    unsubscribe: {
      meta: {
        title: 'Unsubscribe',
        description: 'Unsubscribe'
      },
      sub: {
        project: {
          meta: {
            title: 'Share Project',
            description: 'Share Project'
          }
        }
      }
    },
    shared: {
      meta: {
        title: 'Share',
        description: 'Share',
        keywords: ''
      }
    },
    'card-payment': {
      meta: {
        title: 'Credit Card Payment',
        description: 'Credit Card Payment',
        keywords: ''
      }
    },
    'email-preview': {
      meta: {
        title: 'Preview Email',
        description: 'Preview Email'
      }
    },

    'thank-you': {
      meta: {
        title: 'Thank You',
        description: 'Thank you for inquiring about our products and services. We\'ll get back to you shortly!'
      }
    }
  }
}
